<script setup lang="ts">
import {onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import EmailVerification from "supertokens-web-js/recipe/emailverification";
import {showErrorAlert, showSuccessAlert} from "@/helpers/SweetAlertHelper";
import SimpleLayout from "@/layouts/simple/SimpleLayout.vue";

const route = useRoute();
const router = useRouter();
const verifying = ref(true);
const success = ref(false);

onMounted(async () => {
  const token = route.query.token as string;

  if (!token) {
    showErrorAlert("Token inválido o expirado.");
    verifying.value = false;
    return;
  }

  try {
    const response = await EmailVerification.verifyEmail({
      token,
    });

    if (response.status === "OK") {
      showSuccessAlert("¡Hola!", "Tu correo ha sido verificado con éxito.");
      success.value = true;
      router.push({name: "login"});
    } else {
      showErrorAlert("El enlace de verificación ha expirado o es inválido.");
      router.push({name: "login"});
    }
  } catch (error) {
    showErrorAlert("Error verificando el correo.");
    router.push({name: "login"});
  } finally {
    verifying.value = false;
  }
});
</script>

<template>
  <SimpleLayout>
    <template #content>
      <div class="verify-email-page">
        <h2 v-if="verifying">Verificando tu correo...</h2>
        <h2 v-else-if="success">Correo verificado con éxito. Redirigiendo...</h2>
        <h2 v-else>Error verificando el correo.</h2>
      </div>
    </template>
  </SimpleLayout>
</template>

<style scoped>
.verify-email-page {
  text-align: center;
  margin-top: 50px;
}
</style>